import { render, staticRenderFns } from "./FormAccessRequestReport.vue?vue&type=template&id=0a4cac04&lang=pug"
import script from "./FormAccessRequestReport.vue?vue&type=script&lang=js"
export * from "./FormAccessRequestReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4cac04')) {
      api.createRecord('0a4cac04', component.options)
    } else {
      api.reload('0a4cac04', component.options)
    }
    module.hot.accept("./FormAccessRequestReport.vue?vue&type=template&id=0a4cac04&lang=pug", function () {
      api.rerender('0a4cac04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/report/FormAccessRequestReport.vue"
export default component.exports